"use client";

import { PropsWithChildren } from "react";
import { cn } from "@/utils/classnames";

type Props = {
  className?: string;
  collapsed?: boolean;
};

export const NavigationActions = ({
  className,
  collapsed,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        "flex items-center gap-0.5",
        {
          "ml-auto": collapsed,
          "absolute top-0 right-0 w-full justify-between p-3 md:static md:order-2 md:flex-1 md:justify-end md:p-0":
            !collapsed,
        },
        className
      )}
    >
      {children}
    </div>
  );
};
